import * as ReactDOM from "react-dom";
import * as React from "react";
import App from "./App";
ReactDOM.render(React.createElement(App, null), document.getElementById("root"));
if (module.hot) {
    module.hot.accept();
}
